import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { ContentfulImage, LoadingAnimation, useResponsive } from '@sg/garnish';

import { useCustomizationContent } from '../../hooks';
import { ProductBanner } from '../ProductBanner';

// ─────────────────────────────────────────────────────────────────────────────

export const DressingProductImage = (props: DressingProductImageProps) => {
  const { product, baseUrl, isCustomizationActive } = props;
  const { match } = useResponsive();

  const { fetching } = useCustomizationContent();

  if (fetching) {
    return (
      <View style={styles.container}>
        <LoadingAnimation />
      </View>
    );
  }

  if (baseUrl) {
    return (
      <View style={styles.container}>
        <ContentfulImage
          style={styles.image}
          contentFit="cover"
          contentPosition="bottom center"
          aria-label={product?.name}
          baseUrl={baseUrl}
          options={match([{}, imageConfigSM, imageConfigLG, imageConfigXL])}
        />
      </View>
    );
  }

  if (!product) {
    return null;
  }

  return (
    <View style={styles.container}>
      <ProductBanner
        imgSrc={product.asset.url}
        imgAriaLabel={product.name}
        isCustomizationActive={isCustomizationActive}
      />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.CREAM,
  },
  image: {
    flex: 1,
  },
});

// ─── Constants ──────────────────────────────────────────────────────────────

const fm = 'webp';
const fit = 'fill';
const q = 50;

const imageConfigSM = { fm, fit, q, w: 720 };
const imageConfigLG = { fm, fit, q, w: 1080 };
const imageConfigXL = { fm, fit, q, w: 1440 };

// ─── Types ───────────────────────────────────────────────────────────────────

type DressingProductImageProps = {
  baseUrl: string | undefined;
  product: { name?: string; asset: { url: string } };
  isCustomizationActive: boolean;
};
